
import { Component, EventEmitter, OnInit, Output, Injector } from '@angular/core';
import { Stkpi17Component } from './stkpi17.component';
import { Stkpi17DetailComponent } from './stkpi17-detailPkg.component';
import { MaterialModule } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';

@Component({
  selector: 'app-stkpi17-bill',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, Stkpi17Component, Stkpi17DetailComponent],
  templateUrl: './stkpi17BillPkg.component.html',
  styleUrls: [],
})
export class Stkpi17BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = ' stkpi17'; //###
  override masterPage!: Stkpi17Component;
  override detailPage!: Stkpi17DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
